import { TFunction } from "i18next";
import { UserLoginDTO } from "../domain/models/dto/UserLoginDTO";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";

export const userLoginFields: Fields<UserLoginDTO> = {
    email: {
        min: 1,
        max: 128,
        placeholderKey: `auth.fields.email`,
        type: "email",
        initial: "",
        patternErrorKey: "errors.validation.invalidOption",
    },
    password: {
        min: 8,
        max: 128,
        placeholderKey: `auth.fields.password`,
        type: "password",
        initial: "",
    },
};

export const UserLoginSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userLoginFields);
};
